import { FC } from 'react'

interface Props {
  size?: number
  color?: string
}

export const SecurityIcon: FC<Props> = ({ size = 80, color = '#FFFFFF' }) => (
  <svg width={size} height={size} viewBox="0 0 1024 1024" fill="none">
    <path
      d="M767.3344 378.88v-29.5936a253.2352 253.2352 0 0 0-252.9792-252.9792 253.2864 253.2864 0 0 0-252.9792 252.9792v28.16a159.5392 159.5392 0 0 0-133.12 157.184v238.08A159.488 159.488 0 0 0 287.3856 931.84h446.3616a159.488 159.488 0 0 0 159.3344-159.3344v-238.08A159.5904 159.5904 0 0 0 767.3344 378.88z m-449.6384-29.5936a196.6592 196.6592 0 0 1 393.3184 0v26.0096H317.696z m519.0656 423.424A103.1168 103.1168 0 0 1 733.7472 875.52H287.3856A103.1168 103.1168 0 0 1 184.32 772.7104v-238.08A103.1168 103.1168 0 0 1 287.3856 431.616h446.3616a103.1168 103.1168 0 0 1 103.0144 103.0144z"
      fill={color}
    />
    <path
      d="M514.3552 498.2272A95.744 95.744 0 0 0 486.4 685.4656v91.8016a28.16 28.16 0 0 0 56.32 0v-91.8016a95.744 95.744 0 0 0-28.16-187.2384z m0 135.168a39.424 39.424 0 1 1 39.424-39.424 39.5264 39.5264 0 0 1-39.424 39.424z"
      fill={color}
    />
  </svg>
)
